function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1010.983 -379.823)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-81 -28)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M186.083.237c91.2-19.191,185.877,120.245,129.763,188.087s-77.24,158.4-144.14,152.115S0,266.747,0,171.926C-.809,34.78,129.805,29.169,186.083.237Z",
  transform: "translate(1091.986 409.382)",
  fill: "#ebebeb"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(9 -5.517)"
}, /*#__PURE__*/React.createElement("line", {
  x2: 29.547,
  transform: "translate(1221.5 527.836)",
  fill: "none",
  stroke: "#3a76c4",
  strokeWidth: 10
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1162 503)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(5 -0.483)",
  fill: "rgba(32,93,168,0)",
  stroke: "#3a76c4",
  strokeWidth: 8
}, /*#__PURE__*/React.createElement("circle", {
  cx: 29.5,
  cy: 29.5,
  r: 29.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29.5,
  cy: 29.5,
  r: 25.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-1.832,13.326,34.53,27.284,72.693-3.449,98.949,6.63,39.068,52.7-2.84,36.614Z",
  transform: "translate(71.593 67.232) rotate(-21)",
  fill: "#b5c7df",
  stroke: "#3a76c4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "M7364.894,1581.611l11.99,105.645h-64.149L7302.3,1609.03l-2.871-21.525-.735-5.9h66.2Z",
  transform: "translate(-7287.949 -1512.47)",
  fill: "rgba(32,93,168,0)",
  stroke: "#3a76c4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.875,3.818l52.6,20.3L90.159,0l26.58,10.2L62.315,55.089,0,31.04Z",
  transform: "translate(3.374 67.793) rotate(-21)",
  fill: "#fff",
  stroke: "#3a76c4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8
})), /*#__PURE__*/React.createElement("rect", {
  width: 50,
  height: 19,
  transform: "translate(1250 517.517)",
  fill: "#3a76c4"
}), /*#__PURE__*/React.createElement("rect", {
  width: 56,
  height: 27,
  transform: "translate(1299 513.517)",
  fill: "#3a76c4"
}))));

var SvgFutureEmptyStateIcon = function SvgFutureEmptyStateIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332.68,
    height: 342.308,
    viewBox: "0 0 332.68 342.308",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFutureEmptyStateIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FutureEmptyStateIcon.d35b045c.svg";
export { ForwardRef as ReactComponent };